export default "__VITE_ASSET__e00ef03f__"